'use client';

import { ApplyStep } from './helpers';
import { APPLY_V3_STEPS } from './stepTracking';
import { BundleUpsellContext } from '$/(cms)/-cms/apply-v3/[[...slugs]]/lib/bundleTracking';

export function useApplyStepMeta(
  step: ApplyStep,
  bundleUpsellContext: BundleUpsellContext | undefined,
) {
  if (step === 'bundle-upsell') {
    return {
      leadId: bundleUpsellContext?.leadId ?? '',
      stepName: APPLY_V3_STEPS.bundleUpsell.name,
      stepNumber: APPLY_V3_STEPS.bundleUpsell.number,
    };
  }

  return {
    leadId: '',
    stepName: APPLY_V3_STEPS.capture.name,
    stepNumber: APPLY_V3_STEPS.capture.number,
  };
}
